import SideBySideRecordsTable from "./SideBySideRecordsTable";
import PageMeta from "./PageMeta";

export default function RSAARecordsPage() {
  return (
    <>
      <PageMeta
        title="RSAA Official Club Records | Redruth Sea Angling Association"
        description="Official all-time club fishing records for Redruth Sea Angling Association, Cornwall's sea angling club since 1962."
        keywords="RSAA official club records, sea angling club records Cornwall, Redruth Sea Angling Association records"
        url="https://www.redruthseaanglingassociation.co.uk/rsaa-records"
      />
      <SideBySideRecordsTable
        title="RSAA Official Club Records"
        excelFile="/rsaa_records_2025.xls"
        recordType="official"
      />
    </>
  );
}
